<app-nav-header></app-nav-header>
<div class="wrapper">
    <div id="contanctUsPage">
        <div class="main">
            <!-- Banner -->
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h1>{{ 'contactUs.title' | translate }}</h1>
                    </div>
                </div>
            </div>
            <!-- 表單 -->
            <div class="contactFormArea">
                <div class="contactFormBox">
                    <div class="wordBox">
                        <h4 class="intro">
                            {{ 'contactUs.content' | translate }}
                        </h4>
                        <form
                            [formGroup]="contactForm"
                            class="row">
                            <!-- 姓名 -->
                            <div
                                class="form-group col-12 align-items-center mb-3">
                                <label>
                                    <span class="required">*</span>
                                    <span>{{
                                        'contactUs.name' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <div class="d-flex">
                                        <input
                                            class="mr-2"
                                            pInputText
                                            type="text"
                                            [placeholder]="
                                                'contactUs.firstName'
                                                    | translate
                                            "
                                            formControlName="FirstName"
                                            id="firstName" />
                                        <input
                                            pInputText
                                            type="text"
                                            [placeholder]="
                                                'contactUs.lasrName' | translate
                                            "
                                            formControlName="FamilyName"
                                            id="familyName" />
                                    </div>
                                </div>
                            </div>
                            <!-- 公司 -->
                            <div
                                class="form-group col-12 align-items-center mb-3">
                                <label>
                                    <span class="required hidden">*</span>
                                    <span>{{
                                        'contactUs.companyName' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <input
                                        pInputText
                                        type="text"
                                        placeholder=""
                                        formControlName="Company"
                                        id="company" />
                                </div>
                            </div>
                            <!-- 職稱 -->
                            <div
                                class="form-group col-12 align-items-center mb-3">
                                <label>
                                    <span class="required hidden">*</span>
                                    <span>{{
                                        'contactUs.jobTitle' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <input
                                        pInputText
                                        type="text"
                                        placeholder=""
                                        formControlName="JobTitle"
                                        id="jobTitle" />
                                </div>
                            </div>
                            <!-- 電子郵件 -->
                            <div
                                class="form-group col-12 align-items-center mb-3">
                                <label>
                                    <span class="required">*</span>
                                    <span>{{
                                        'contactUs.email' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <input
                                        pInputText
                                        type="text"
                                        placeholder=""
                                        formControlName="Mail"
                                        id="mail" />
                                </div>
                            </div>
                            <!-- 電話 -->
                            <div
                                class="form-group col-12 align-items-center mb-3">
                                <label>
                                    <span class="required hidden">*</span>
                                    <span>{{
                                        'contactUs.phoneNumber' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <input
                                        pInputText
                                        type="text"
                                        placeholder=""
                                        formControlName="Phone"
                                        id="phone" />
                                </div>
                            </div>
                            <!-- 主旨 -->
                            <div
                                class="form-group col-12 align-items-center mb-3">
                                <label>
                                    <span class="required">*</span>
                                    <span>{{
                                        'contactUs.topic' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <input
                                        pInputText
                                        type="text"
                                        placeholder=""
                                        formControlName="Subject"
                                        id="subject" />
                                </div>
                            </div>
                            <!-- 問題與反映 -->
                            <div class="form-group col-12">
                                <label>
                                    <span class="required hidden">*</span>
                                    <span>{{
                                        'contactUs.purpose' | translate
                                    }}</span>
                                </label>
                                <div class="col pr-0 field-cus">
                                    <textarea
                                        pInputText
                                        type="text"
                                        placeholder=""
                                        formControlName="Content"
                                        id="content"
                                        rows="5"></textarea>
                                </div>
                            </div>
                        </form>
                        <div
                            class="d-flex justify-content-center align-items-center mt-4">
                            <button
                                type="button"
                                class="submit-btn"
                                (click)="onSubmitContact()">
                                {{ 'contactUs.sumbit' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
